// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';

export const MenuIcon = styled(SVGIcon)`
    height: 1em;
    width: 1em;
`;

export const MenuContainer = styled.div`
    position: absolute;
    z-index: 500;
    bottom: ${props => (props.isSmall ? '-1em' : '-.75em')};
    left: 0;
    width: 100%;
    font-size: ${props => (props.isSmall ? '2em' : '2.5em')};
`;

export const Menu = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 500;
    width: 100%;
    margin: 0;
`;

export const MenuItem = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${props => (props.enabled ? '#000000' : '#CCCCCC')};
    cursor: ${props => (props.enabled ? 'pointer' : 'auto')};
    flex-grow: 1;

    a {
        color: ${props => (props.enabled ? '#000000' : '#CCCCCC')};
    }

    svg g {
        fill: ${props => (props.enabled ? '#000000' : '#CCCCCC')};
    }
`;



// WEBPACK FOOTER //
// ./src/components/bulbs/menu/index.js